import React from 'react';

const SvgClose = (props) => (
  <svg width="100%" height="100%" viewBox="-5 -5 20 20" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.166 9.698L5.017 6.55 1.87 9.7C.848 10.633-.685 9.186.337 8.165l3.149-3.149L.336 1.87C-.683.848.849-.685 1.87.337l3.148 3.149 3.15-3.15c1.02-1.02 2.467.512 1.531 1.533L6.55 5.017C7.571 6.04 8.677 7.06 9.7 8.167c.935 1.02-.596 2.467-1.533 1.531z"
      opacity={1}
    />
  </svg>
);

export default SvgClose;
